import english from './en/auth.json';
import french from './fr/auth.json';
import arabic from './ar/auth.json';

// Authentication recovery must remain available while remote catalogs load.
const authResources = {
  en: { auth: english },
  fr: { auth: french },
  ar: { auth: arabic },
};

export default authResources;
